/*class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    console.log("click");
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    console.log("opening");
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    console.log("closing");
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);*/

class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeBtn = this.querySelector('button[type="button"]');

    this.openedAt = 0; // ⏱️ timestamp lock

    this.summaryToggle.setAttribute('role', 'button');

    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onBodyClick = this.onBodyClick.bind(this);

    // ESC key
    this.detailsContainer.addEventListener('keyup', (e) => {
      if (e.code?.toUpperCase() === 'ESCAPE') this.close();
    });

    this.summaryToggle.addEventListener('click', this.onSummaryClick);

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.isOpen() ? this.close() : this.open();
  }

  onBodyClick(event) {
    // 🔒 BLOCK closing if opened < 2 seconds ago
    if (Date.now() - this.openedAt < 2000) return;

    const clickedInside = this.contains(event.target);
    const isOverlay = event.target.classList?.contains('modal-overlay');

    if (!clickedInside || isOverlay) {
      this.close(false);
    }
  }

  open() {
    this.openedAt = Date.now(); // ⏱️ START LOCK

    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    // Attach body click AFTER open
    document.addEventListener('click', this.onBodyClick, true);
  }

  close(focusToggle = true) {
    // 🔒 BLOCK close if within 2 seconds
    if (Date.now() - this.openedAt < 2000) return;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('click', this.onBodyClick, true);
  }
}

customElements.define('details-modal', DetailsModal);
